import { useEffect, useRef, useState } from "react";
import { formatCurrency } from "@/utils/formatCurrency.js";
import { paymentLabel } from "@/utils/onlinePurchase.js";
import api from "@/api/api.js";
import $ from "jquery";
import "datatables.net";
import { capitalizeFirstLetter } from "@/utils/stringUtils.js";
import languageES from "datatables.net-plugins/i18n/es-MX";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const FoliosHome = () => {
  const { t } = useTranslation();
  const tableRef = useRef(null);
  const dataTable = useRef(null);

  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState("all");
  const filterRef = useRef("all");

  const applyFilter = (f) => {
    filterRef.current = f;
    setActiveFilter(f);
    dataTable.current?.ajax.reload();
  };

  useEffect(() => {
    if (!tableRef.current) return;

    const STYLE_ID = "folios-row-style";
    if (!document.getElementById(STYLE_ID)) {
      const styleEl = document.createElement("style");
      styleEl.id = STYLE_ID;
      styleEl.textContent = `
        .folio-approved td { background-color: #e8f5e9 !important; }
        .folio-rejected td { background-color: #fdecea !important; }
        .folio-pending td { background-color: #fff8e1 !important; }
      `;
      document.head.appendChild(styleEl);
    }

    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().clear().destroy();
      $(tableRef.current).empty();
    }

    dataTable.current = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      language: languageES,
      createdRow: (row, data) => {
        if (data.approvalStatus === 1) $(row).addClass("folio-approved");
        else if (data.approvalStatus === 0) $(row).addClass("folio-rejected");
        else $(row).addClass("folio-pending");
      },
      async ajax(dataTablesParams, callback) {
        try {
          const response = await api.get("/request_tickets", {
            params: {
              page: dataTablesParams.start / dataTablesParams.length + 1,
              itemsPerPage: dataTablesParams.length,
              search: dataTablesParams.search.value,
              // Pendiente es lo que nadie ha resuelto: una compra pagada en
              // línea se aprueba sola y nunca tiene quién la aprobó.
              approvalStatus:
                filterRef.current === "pendientes"
                  ? "null"
                  : filterRef.current === "liberados"
                    ? "not_null"
                    : undefined,
              invoiceRequestedAt:
                filterRef.current === "factura_solicitada"
                  ? "not_null"
                  : undefined,
            },
          });

          callback({
            data: response.data["hydra:member"].map((item, index) => ({
              ...item,
              uniqueKey: `${item.id || "temp"}-${index}`, // Generar una clave única si `id` está vacío
            })),
            recordsTotal: response.data["hydra:totalItems"],
            recordsFiltered: response.data["hydra:totalItems"],
          });
        } catch (error) {
          console.error("Error al cargar datos:", error);
          callback({ data: [] });
        }
      },
      columns: [
        { title: capitalizeFirstLetter(t("id")), data: "id" },
        {
          title: capitalizeFirstLetter(t("package name")),
          data: "packageName",
        },
        {
          title: capitalizeFirstLetter(t("quantity folios")),
          data: "quantityTickets",
        },
        {
          title: capitalizeFirstLetter(t("requested ago")),
          data: "createdAtAgo",
        },
        {
          title: capitalizeFirstLetter(t("requested by who")),
          render: (data, type, row) => {
            return row.requestUser.userProfile.fullName;
          },
        },
        {
          title: "Monto",
          orderable: false,
          render: (data, type, row) =>
            row.priceCents == null ? "-" : formatCurrency(row.priceCents / 100),
        },
        {
          title: "Pago",
          orderable: false,
          render: (data, type, row) => paymentLabel(row),
        },
        {
          title: "Estado",
          orderable: false,
          render: (data, type, row) => {
            if (row.approvalStatus === 1)
              return '<span class="badge bg-success">Aprobado</span>';
            if (row.paymentOrder?.status === "expirada")
              return '<span class="badge bg-secondary">Vencido sin pago</span>';
            if (row.approvalStatus === 0)
              return '<span class="badge bg-danger">Rechazado</span>';
            return '<span class="badge bg-warning text-dark">Pendiente</span>';
          },
        },
        {
          title: "Factura",
          orderable: false,
          render: (data, type, row) => {
            if (row.invoiceOriginalName)
              return '<span class="badge bg-success">Atendida</span>';
            if (row.invoiceRequestedAt) {
              const d = new Date(row.invoiceRequestedAt);
              const fecha = Number.isNaN(d.getTime())
                ? ""
                : d.toLocaleDateString("es-MX", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                  });
              return `<span class="badge bg-info text-dark">Solicitada</span>${fecha ? ` <small class="text-muted">${fecha}</small>` : ""}`;
            }
            return '<span class="text-muted">Sin solicitar</span>';
          },
        },
        {
          title: capitalizeFirstLetter(t("actions")),
          render: (data, type, row) => {
            const requestTicketId = row["@id"].split("/").pop();
            console.log("row: " + row.id);
            return `
                            <button class="btn btn-warning btn-detail-request-folio" data-id="${requestTicketId}">Detalle</button>
                        `;
          },
        },
      ],
      rowId: "id",
    });

    const handleShowClick = (event) => {
      const request_ticket_id = $(event.currentTarget).data("id");
      console.log("request_ticket_id: " + request_ticket_id);
      navigate(`/folios/${request_ticket_id}/show`);
    };

    $(tableRef.current).on(
      "click",
      ".btn-detail-request-folio",
      handleShowClick,
    );

    return () => {
      if ($.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
      $(tableRef.current).off(
        "click",
        ".btn-detail-request-folio",
        handleShowClick,
      );
    };
  }, []);

  return (
    <>
      <>
        <div className="col">
          <div className="card">
            <div className="card-body p-1">
              <div className="card-title p-1 d-flex align-items-center flex-wrap gap-2">
                <h5 className="card-title p-1 mb-0">Historial de folios</h5>
                <div className="btn-group btn-group-sm ms-auto" role="group">
                  <button
                    type="button"
                    className={`btn ${activeFilter === "all" ? "btn-primary" : "btn-outline-primary"}`}
                    onClick={() => applyFilter("all")}
                  >
                    Todos
                  </button>
                  <button
                    type="button"
                    className={`btn ${activeFilter === "pendientes" ? "btn-primary" : "btn-outline-primary"}`}
                    onClick={() => applyFilter("pendientes")}
                  >
                    Pendientes
                  </button>
                  <button
                    type="button"
                    className={`btn ${activeFilter === "liberados" ? "btn-primary" : "btn-outline-primary"}`}
                    onClick={() => applyFilter("liberados")}
                  >
                    Liberados
                  </button>
                  <button
                    type="button"
                    className={`btn ${activeFilter === "factura_solicitada" ? "btn-primary" : "btn-outline-primary"}`}
                    onClick={() => applyFilter("factura_solicitada")}
                  >
                    Factura solicitada
                  </button>
                </div>
              </div>
              <div className={"card-body"}>
                <table
                  ref={tableRef}
                  className="display"
                  style={{ width: "100%" }}
                ></table>
              </div>
            </div>
          </div>
        </div>
      </>
    </>
  );
};

export default FoliosHome;
